module.exports = __webpack_public_path__ + "static/slack-noise-3-041d63cfd17e2ea51b44f10c1de72683.png";